'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';

export const AuthRedirectHandler = () => {
    const router = useRouter();

    useEffect(() => {
        const checkRedirect = async () => {
            try {
                const redirectPath = localStorage.getItem('redirectAfterAuth');
                if (redirectPath) {
                    // Clear the redirect path
                    localStorage.removeItem('redirectAfterAuth');
                    // Redirect to the stored path
                    router.push(redirectPath);
                }
            } catch (error) {
                console.error('Error checking redirect:', error);
            }
        };

        checkRedirect();
    }, [router]);

    return null;
}; 